module.exports = __webpack_public_path__ + "static/367117_3_0-56f8fa7571cb8abf848249e772763f8a.woff";